import * as React from "react";
import ReactGA from 'react-ga4'
import { useLocation } from 'react-router'

interface WrapperProps {
    initialized: boolean;
    children: React.PropsWithChildren<any>
}


export function Wrapper(props: WrapperProps) {
    const location = useLocation()

    React.useEffect(() => {
        if (props.initialized) {
            ReactGA.send("pageview");
            ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
            // ReactGA.pageview(location.pathname + location.search);
        }
    }, [props.initialized, location]);

    return (
        <>
            {props.children}
        </>

    );
}
